(function (angular) {
	'use strict';

	angular
		.module('serviceLevelModule')
		.controller('SelectCorePlan', [
			'$q',
			'$scope',
			'ServiceLevelFactory',
			'urlFactory',
			SelectCorePlanFunction
		]);

	function SelectCorePlanFunction(
		$q,
		$scope,
		ServiceLevelFactory,
		urlFactory
	) {
		var selectCorePlan = this;
		var nextServiceLevelName = 'CORE';

		function continueToNewAllocation() {
			selectCorePlan.investAndUpgradeForm = {
				riaPlanId: selectCorePlan.newRiaPlanId,
				serviceLevelUpgrade: nextServiceLevelName
			};
			
			urlFactory.submitFormById('invest-and-upgrade-form');
		}

		function submitUpgrade(riaPlanId) {
			ServiceLevelFactory.upgradeServiceLevelAndRiaPlan(nextServiceLevelName, riaPlanId)
				.then(function() {
					urlFactory.redirect('/account/upgrade/' + nextServiceLevelName.toLowerCase()  + '/success');
				});
		}

		selectCorePlan.continue = function(planName) {
			selectCorePlan.ctaDisabled = true;
			selectCorePlan.newRiaPlanId = selectCorePlan.planMap[planName];
			
			$scope.$broadcast('planCta:formSubmitted', {
				planName: planName,
				submitted: true
			});
			
			if(selectCorePlan.isInvestAndUpgrade) {
				continueToNewAllocation();
			} else {
				submitUpgrade(selectCorePlan.newRiaPlanId);
			}
		};

		selectCorePlan.$onInit = function() {
			angular.extend(selectCorePlan, globalConfig);
			selectCorePlan.ctaDisabled = false;
		};
	}
})(window.angular);